app.service('saveDeliveryData', function (modal, loading, broker, pageConfig, console, holidayPromotion) {
	let isSaved = false;

	function send(data, callback, callbackError) {
		const config = pageConfig.getData('order');
		if (config.pageType != 'basket' && data.pickupPointCode && data.pickupPointCode == config.pickupPointCode) {
			console.log('NIE MA POTRZEBY ZAPISU PUNKTU na K3, zapisany: ' + config.pickupPointCode);
			callback(false);
			return;
		} else if (config.pageType == 'basket' && data.pickupPointCode && config.deliveryPoint && config.deliveryPoint.code && data.pickupPointCode == config.deliveryPoint.code) {
			console.log('NIE MA POTRZEBY ZAPISU PUNKTU na K2, zapisany: ' + config.deliveryPoint.code);
			callback(false);
			return;
		}
		if (!isSaved) {
			isSaved = true;
			loading.start();
			$.ajax({
				url: config.pageType == 'basket' ? '/pickup-point-selection-edit.ltr' : '/order-path-pickup-point-delivery-edit.ltr',
				dataType: 'json',
				contentType: 'application/json',
				type: 'POST',
				data: JSON.stringify(data),
				success: function (json) {
					isSaved = false;
					if (json.status == 'SUCCESS') {
						if (config.pageType == 'basket') {
							broker.trigger('REFRESH_BASKET_VIEW');
						} else {
							holidayPromotion.refresh();
							broker.trigger('K3_REFRESH', function () {
								callback(true);
							});
						}
					} else {
						if (callbackError) {
							callbackError();
						} else {
							modal.alert(json.messages);
						}
					}
				},
				error: function () {
					isSaved = false;
					if (callbackError) {
						callbackError();
					} else {
						modal.alert('Błąd zapisania wybranego punktu odbioru. Spróbuj ponownie.')
					}
				}
			});
		}
	}

	return {
		send
	};
});
